module.exports = __webpack_public_path__ + "6bbe53620184e09a87bd293fa0a19bdb.png";